import { Pagination } from "antd";
import { Link } from "react-router-dom"
import Loadar from "../../../common/loader/Loader";
import ExportPdf from "../../../common/exportPdf/ExportPdf";

function VirtualWallList({ data, onChangeVal, totalCount, loading }) {
    return (
        <>
            {loading && <Loadar />}
            <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b>All virtual wallet List</b></h4>
                                        <div>
                                            <Link className="btn btn-primary btn-sm" to="/admin/wallet/add/virtual-wallet" role="button" aria-controls="offcanvasExample">+  ADD Virtual Wallets </Link>
                                            {/* <button type="button" className="btn btn-secondary btn-sm" >
                                        + Invite Employee
                                    </button> */}
                                            <ExportPdf />
                                        </div>
                                    </div>
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer">
                                        {/* <div className="dt-buttons"><button className="dt-button buttons-excel buttons-html5 btn btn-sm border-0" tabIndex={0} aria-controls="empoloyees-tblwrapper" type="button"><span><i className="fa-solid fa-file-excel" /> Download Retailer</span></button> </div> */}
                                       <table id="table-to-xls" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
                                            <thead>
                                                <tr role="row">
                                                    <th className="sorting_asc" style={{ width: '122.312px' }}>
                                                        Date
                                                    </th>
                                                    <th>Wallet Pool</th>
                                                    <th>Type</th>
                                                    <th className="sorting" style={{ width: '120px' }}>Amount</th>
                                                    <th className="sorting" style={{ width: '130px' }}>Transaction Type</th>
                                                    <th className="sorting" style={{ width: '160px' }}>Message</th>
                                                    <th className="sorting" style={{ width: '100px' }}>Closing Bal</th>
                                                    <th className="sorting" style={{ width: '100px' }}>Opening Bal</th>
                                                    <th className="sorting" style={{ width: '96px' }}>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data && data?.map((item) => {
                                                    const walletLabel = 
                                                        item?.wallet_type === 'aeps_wallet' ? 'AEPS Wallet' :
                                                        item?.wallet_type === 'cashback_wallet' ? 'Cashback Wallet' : 'Main Wallet';
                                                    const walletBadgeClass = 
                                                        item?.wallet_type === 'aeps_wallet' ? 'bg-purple text-white' :
                                                        item?.wallet_type === 'cashback_wallet' ? 'bg-warning text-dark' : 'bg-primary text-white';

                                                    return <tr role="row" className="odd" key={item?._id}>
                                                        <td className="sorting_1">
                                                            <span>{typeof item?.createdAt === 'string' ? item?.createdAt : (item?.createdAt ? new Date(item?.createdAt).toLocaleString('en-GB') : 'N/A')}</span>
                                                        </td>
                                                        <td>
                                                            <span className={`badge ${walletBadgeClass}`} style={{ fontSize: '0.75rem' }}>
                                                                {walletLabel}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className={`badge ${item?.type === 'credit' ? 'bg-success' : 'bg-danger'}`} style={{ fontSize: '0.72rem' }}>
                                                                {item?.type === 'credit' ? '+ Credit' : '- Debit'}
                                                            </span>
                                                        </td>
                                                        <td className="fw-bold">₹{Number(item?.amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td>{item?.trans_type}</td>
                                                        <td style={{ fontSize: '0.85rem' }}>
                                                            {item?.message}
                                                        </td>
                                                        <td className="fw-semibold">₹{Number(item?.c_bal || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td>₹{Number(item?.o_bal || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td>
                                                            <span className="badge badge-success text-light border-0" style={{ backgroundColor: `${item?.approve === true ? 'blue' : '#bc3922ab'}`, fontSize: `${item?.approve === false ? '0.8rem' : ''}` }}>{item?.approve == true ? 'varified' : 'un varified'}</span>
                                                        </td>
                                                    </tr>
                                                })}

                                            </tbody>
                                        </table>
                                        < div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                            Total {totalCount} entries
                                        </div>
                                        <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                            <Pagination
                                                // showSizeChanger
                                                // onShowSizeChange={''}

                                                defaultCurrent={1}
                                                onChange={onChangeVal}
                                                total={totalCount}
                                            />
                                        </div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >

            </section>
        </>
    )
}

export default VirtualWallList